import { createColumn, defaultColumns, inputTextField, relationField, booleanComponent } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Event',
    field: 'eventId',
    section: '',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'eventId',
      fk: 'id',
      namespace: 'event',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Hidden',
    field: 'hidden',
    section: '',
    defaultValue: false,
    type: 'boolean',
    component: booleanComponent
  }),
  createColumn({
    label: 'Required',
    field: 'required',
    section: '',
    defaultValue: false,
    type: 'boolean',
    component: booleanComponent
  }),
  createColumn({
    label: 'Applies to all Attendees',
    field: 'appliesToAll',
    section: '',
    defaultValue: true,
    type: 'boolean',
    component: booleanComponent
  }),
  createColumn({
    label: 'Show for Not Attending',
    field: 'showForNotAttending',
    section: '',
    defaultValue: true,
    type: 'boolean',
    component: booleanComponent
  }),
  createColumn({
    label: 'Question Type',
    field: 'questionType',
    section: '',
    component: {
      is: 'q-select',
      filterIs: 'select-filter',
      props: {
        options: [
          {
            label: 'Open Text',
            value: 'text'
          },
          {
            label: 'Select',
            value: 'select'
          },
          {
            label: 'Yes / No',
            value: 'bool'
          },
          {
            label: 'Address',
            value: 'address'
          }
        ]
      }
    }
  }),
  createColumn({
    label: 'Question',
    field: 'questionText',
    section: '',
    component: inputTextField({ type: 'text', req: true, max: 255 })
  }),
  createColumn({
    label: 'Invoice Description',
    field: 'invoiceDesc',
    section: '',
    component: inputTextField({ type: 'text', req: true, max: 255 })
  }),
  createColumn({
    label: 'Cost Modifier',
    field: 'costModifier',
    section: '',
    component: inputTextField({ type: 'number', req: false, max: 10, money: true })
  }),
  createColumn({
    label: 'Sort',
    field: 'sort',
    section: '',
    component: inputTextField({ type: 'number', req: false, max: 4 })
  })
].concat(defaultColumns)
